// extracted by mini-css-extract-plugin
export var avatar = "AuthorAvatars-module--avatar--faa81";
export var avatars = "AuthorAvatars-module--avatars--3610f";
export var image = "AuthorAvatars-module--image--c2392";
export var initials = "AuthorAvatars-module--initials--bff8d";
export var names = "AuthorAvatars-module--names--5f246";
export var root = "AuthorAvatars-module--root--2ea54";